import React, { useEffect, useState } from "react";
import "./Olia.css"
import ReceptOlia from './ReceptOlia'
import axios from "axios";
import { config } from "../../../confi";

function Olia() {



  const [show, setShow] = useState(false);
  
  const [start_date,setstart_date] = useState('')
  const [days,setdays] =  useState('')
  const [resdata, setresdata] = useState([]);
  const [checkdate, setcheckdate] = useState("");
  const [loading, setLoading] = useState(false);
  const [flash, setflash] = useState(false);
  const [msg, setmsg] = useState("");
  const [msg_R, setmsg_R] = useState("");

  const input_handler_date = (e) => {
    setstart_date(e.target.value);
  };

  const input_handler_day = (e) => {
    setdays(e.target.value);
  };

 //// ----------- check olia date  avaliable------////

  const FetchHandler = async (e) => {
    e.preventDefault();
    setresdata([])
    setsuccess(false);
    setmsg_R('')
    setShow(false);
    if (start_date === ""||days ==='') {
      setflash(true)
      setmsg('please fill date & days')
      return;
    }

    let reqbody = JSON.stringify({fn:"common_fun",an:"fn_ck_sh",payload:{dates_s:start_date,days:days}});

    try {
      setLoading(true);
      setShow(false);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log(response);
 
      if (response.status === 200  ) {
         if(response.data.status === "0"){

           setflash(true);
           setmsg(response.data.msg);
           setShow(true);

         }


         else {
            setflash(true)
          setresdata(response.data.data_slot)
          setmsg(response.data.msg);
         }
       
        }
       else {
        setflash(true);

        setmsg(response.data.msg);
      }
    } catch (error) {}
    setLoading(false);
  };




/// --- success msg  -------/////
  let [success, setsuccess] = useState(false);
  const success_msg = (no, msg) => {
    setstart_date('')
    setresdata([])
    setmsg_R(msg);
    setsuccess(no);
  };




  return (
    <>
    
    <div className="MittiDetails">
      <div className="button-Dates">
        <button>Display Olia Dates</button>
      </div>
      <div className="book">
        <span style={{ colorL:"blue" }}>Block Mitti Date</span>
      </div>
      <div className="Fetch-Receipt">
        <div>
          <label className="MittiDetails-label">Date</label>
          <br></br>
          <div className="need-Fetch-Receipt">
            <input
              className="MittiDetails-input"
              type="date"
              value={start_date}
              onChange={input_handler_date}
            ></input>
            <input className='olia-input-day'  placeholder='Days' 
             value={days}
             onChange={input_handler_day}
            />
            <button className="Receipt-card-submit" onClick={FetchHandler} >
              Fetch
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
    {flash && <p style={{ color: "green" }}>{msg}</p>}


    {success === "1" ? (
  <p className="book_msg"> {msg_R} </p>
) : (  <ReceptOlia
  free_date={start_date}
  days ={days}
  status={show}
  res_data={resdata.length > 0 ? resdata[0] : {}}
  success_msg={success_msg}
  inputDisabled={resdata.length > 0 ? true : false}
  buttonDisabled={resdata.length > 0 ? true : false}
  />
  
)}



</div>




    </>
  )
}

export default Olia

